import { render, staticRenderFns } from "./PublishStatusIcons.vue?vue&type=template&id=21512178&scoped=true"
import script from "./PublishStatusIcons.vue?vue&type=script&lang=js"
export * from "./PublishStatusIcons.vue?vue&type=script&lang=js"
import style0 from "./PublishStatusIcons.vue?vue&type=style&index=0&id=21512178&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21512178",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21512178')) {
      api.createRecord('21512178', component.options)
    } else {
      api.reload('21512178', component.options)
    }
    module.hot.accept("./PublishStatusIcons.vue?vue&type=template&id=21512178&scoped=true", function () {
      api.rerender('21512178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/PublishStatusIcons.vue"
export default component.exports